import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Loader2 } from 'lucide-react';
import UsnStickerPrinter from './UsnStickerPrinter';

// Dialog wrapper: fetches USN groups lazily (on open) and renders the printer.
// `fetchGroups` returns a Promise resolving to [{ bundle_code, usns[], ... }].
export const UsnStickerDialog = ({ open, onOpenChange, title, screenKey, fetchGroups }) => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const fetchRef = useRef(fetchGroups);
  fetchRef.current = fetchGroups;

  useEffect(() => {
    if (!open) return;
    let active = true;
    setLoading(true);
    setGroups([]);
    Promise.resolve(fetchRef.current())
      .then((g) => { if (active) setGroups(g || []); })
      .catch(() => { if (active) setGroups([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="usn-sticker-dialog">
        <DialogHeader>
          <DialogTitle>{title || 'Print USN Stickers'}</DialogTitle>
          <DialogDescription>Send the USN stickers for this job order to your label printer.</DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="py-10 text-center text-gray-500"><Loader2 className="w-6 h-6 animate-spin mx-auto mb-2" /> Loading USNs…</div>
        ) : (
          <UsnStickerPrinter groups={groups} screenKey={screenKey} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default UsnStickerDialog;
